module.exports = __webpack_public_path__ + "img/exp-date.f90063b3.svg";